import { cleanStringFromNonDigits } from '@hrlogics/helper-utils';

import { Nullable } from '@clearverify/types';

import { PlatformStaffWhere, UserStatus, usePlatformStaffListQuery } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { gql } from 'src/utils/gql';
import { getUserFullNameFilter } from 'src/utils/user';

type ClearVerifyTableListProps = {
  notifyOnNetworkStatusChange?: boolean;
};

export const useClearVerifyStaffTableList = ({
  notifyOnNetworkStatusChange,
}: ClearVerifyTableListProps = {}) => {
  const searchQueryVariables = useSearchQueryVariables(prepareSearchFilter);
  const { filter, sortQueryVariable, paginationQueryVariables } = useFilterStorage();

  const status = filter.status as Nullable<UserStatus[]>;

  const { data, loading, refetch } = usePlatformStaffListQuery({
    variables: {
      filter: gql.wrapToAND([
        searchQueryVariables,
        status
          ? {
              user: {
                status: {
                  in: status,
                },
              },
            }
          : {},
      ]),
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    },
    notifyOnNetworkStatusChange,
  });

  return {
    clearVerifyStaffCount: data?.platformStaffCount || 0,
    clearVerifyStaff: data?.platformStaffList ?? [],
    refetch,
    loading,
  };
};

const prepareSearchFilter = (searchValue: Nullable<string>): PlatformStaffWhere => {
  if (!searchValue || searchValue.trim() === '') {
    return {};
  }
  const phoneNumber = cleanStringFromNonDigits(searchValue);

  return {
    user: {
      OR: [
        getUserFullNameFilter(searchValue),
        {
          email: {
            contains: searchValue.toLowerCase(),
          },
        },
        phoneNumber
          ? {
              phoneNumber: {
                contains: cleanStringFromNonDigits(searchValue),
              },
            }
          : {},
      ],
    },
  };
};
